import { defineComponent, shallowRef, computed, onErrorCaptured, openBlock, createElementBlock, renderSlot, createVNode } from 'vue';
import { Warning } from '@ssml-editor/base';
import _sfc_main$2 from './editor-footer.vue.js';
import EditorTextArea from './editor-text-area.js';
import _sfc_main$1 from './editor-toolbar.vue.js';
import { DefaultEditorConfig } from '../constant/editor-config.js';
import '@ssml-editor/core';
import '../node_modules/.pnpm/slate-vue3@0.13.2_vue@3.5.31_typescript@5.9.3_/node_modules/slate-vue3/dist/create-editor-z7CFqjGE.js';
import { ParagraphModule } from '../editor/module/paragraph/module.js';
import { l as lodashExports } from '../_virtual/lodash.js';

const generateConfig = (config) => {
  return lodashExports.assign(lodashExports.merge({}, DefaultEditorConfig, config), {
    modules: [ParagraphModule, ...config?.modules || []]
  });
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "editor",
  props: {
    config: {}
  },
  emits: ["created", "change", "selectionChange", "valueChange", "destroyed", "focus", "blur", "maxLength", "error", "warning"],
  setup(__props, { expose: __expose, emit: __emit }) {
    const emit = __emit;
    const editorRef = shallowRef();
    const newConfig = computed(() => generateConfig(__props.config));
    const editorTextAreaOnCreatedHandler = (editor, htmlElement) => {
      editorRef.value = editor;
      emit("created", editor, htmlElement);
    };
    const editorTextAreaOnChangeHandler = (editor, htmlElement, options) => {
      emit("change", editor, htmlElement, options);
    };
    const editorTextAreaOnSelectionChangeHandler = (editor, htmlElement, options) => {
      emit("selectionChange", editor, htmlElement, options);
    };
    const editorTextAreaOnValueChangeHandler = (editor, htmlElement, options) => {
      emit("valueChange", editor, htmlElement, options);
    };
    const editorTextAreaOnDestroyedHandler = (editor, htmlElement) => {
      editorRef.value = void 0;
      emit("destroyed", editor, htmlElement);
    };
    const editorTextAreaOnFocusHandler = (editor, htmlElement) => {
      emit("focus", editor, htmlElement);
    };
    const editorTextAreaOnBlurHandler = (editor, htmlElement) => {
      emit("blur", editor, htmlElement);
    };
    const editorTextAreaOnMaxLengthHandler = (editor, htmlElement) => {
      emit("maxLength", editor, htmlElement);
    };
    __expose({
      editor: editorRef
    });
    onErrorCaptured((error) => {
      if (Warning.isWarning(error)) {
        emit("warning", error);
        return false;
      } else if (Error.isError(error)) {
        emit("error", error);
        return false;
      }
      return true;
    });
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", { class: "se-editor" }, [
        renderSlot(_ctx.$slots, "header", {
          config: newConfig.value,
          editor: editorRef.value
        }),
        renderSlot(_ctx.$slots, "toolbar", {
          config: newConfig.value,
          editor: editorRef.value
        }, () => [
          createVNode(_sfc_main$1, {
            config: newConfig.value,
            editor: editorRef.value
          }, null, 8, ["config", "editor"])
        ]),
        renderSlot(_ctx.$slots, "textArea", {
          config: newConfig.value,
          onCreated: editorTextAreaOnCreatedHandler,
          onChange: editorTextAreaOnChangeHandler,
          onSelectionChange: editorTextAreaOnSelectionChangeHandler,
          onValueChange: editorTextAreaOnValueChangeHandler,
          onDestroyed: editorTextAreaOnDestroyedHandler,
          onFocus: editorTextAreaOnFocusHandler,
          onBlur: editorTextAreaOnBlurHandler,
          onMaxLength: editorTextAreaOnMaxLengthHandler
        }, () => [
          createVNode(EditorTextArea, {
            config: newConfig.value,
            onCreated: editorTextAreaOnCreatedHandler,
            onChange: editorTextAreaOnChangeHandler,
            onSelectionChange: editorTextAreaOnSelectionChangeHandler,
            onValueChange: editorTextAreaOnValueChangeHandler,
            onDestroyed: editorTextAreaOnDestroyedHandler,
            onFocus: editorTextAreaOnFocusHandler,
            onBlur: editorTextAreaOnBlurHandler,
            onMaxLength: editorTextAreaOnMaxLengthHandler
          }, null, 8, ["config"])
        ]),
        renderSlot(_ctx.$slots, "footer", {
          config: newConfig.value,
          editor: editorRef.value
        }, () => [
          createVNode(_sfc_main$2, {
            config: newConfig.value,
            editor: editorRef.value
          }, null, 8, ["config", "editor"])
        ])
      ]);
    };
  }
});

export { _sfc_main as default, generateConfig };
//# sourceMappingURL=editor.vue.js.map
